export enum NewsStatus {
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export function newsStatuses() {
  return [NewsStatus.ARCHIVED, NewsStatus.PUBLISHED];
}
